import styled from 'styled-components'
import { Checkbox, Collapse, Alert, Modal, Icon } from 'antd'
import { title, themeColor } from '@edulastic/colors'

export const DragCrad = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: ${({ noPadding }) => !noPadding && '30px'};
`

export const DragHandler = styled.div`
  width: 36px;
  cursor: move;
  text-align: center;
`

export const ReviewItemWrapper = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'calc(100% - 30px)')};
  background: white;

  &:first-child {
    border-top: 1px solid #e8e8e8;
  }
`

export const QuestionCheckbox = styled(Checkbox)`
  display: block;
  margin-top: 10px;
`

export const GroupCollapse = styled(Collapse)`
  &.ant-collapse {
    border: none;
    background: none;
    & > .ant-collapse-item {
      border: none;
      margin-bottom: 5px;
    }
  }
  .ant-collapse-extra {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 20px;
  }
  &.ant-collapse-icon-position-right {
    & > .ant-collapse-item {
      & > .ant-collapse-header {
        padding: 4px 16px;
        height: 50px;
        align-items: center;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        font-weight: 600;
        color: ${title};
        background: #f8f8f8;
        border: 1px solid #dfdfdf;
        border-radius: 8px;
        .ant-collapse-arrow {
          color: ${themeColor};
        }
      }
      &.ant-collapse-item-active {
        & > .ant-collapse-header {
          border-radius: 8px 8px 0px 0px;
        }
      }
      .ant-collapse-content {
        border: none;
        & > .ant-collapse-content-box {
          padding: 15px 0px;
        }
      }
    }
  }
`

export const InfoDiv = styled.div`
  display: flex;
  flex-direction: ${({ hasSections }) => (hasSections ? 'row' : 'column')};
  align-items: center;
  line-height: 16px;
  padding: 0px 10px;
  justify-content: ${({ hasSections }) => hasSections && 'space-evenly'};
  gap: ${({ hasSections }) => hasSections && '10px'};
`

export const Text = styled.div`
  font-size: 9px;
  text-transform: uppercase;
  color: ${({ color }) => color || title};
  font-weight: 600;
`

export const Count = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${({ color }) => color || title};
`

export const QuestionIndex = styled.div``

export const StyledSpinnerContainer = styled.div`
  padding: 10px;
  > div {
    position: relative;
    top: unset;
    left: unset;
    transform: unset;
  }
  .drop-area-indication {
    display: none;
  }
  .show-drop-area .drop-area-indication {
    display: flex;
  }
  .show-drop-area .space-element {
    display: none;
  }
`
export const DropAreaIndication = styled.div`
  width: 75%;
  border: 3px dashed #b4bcc4;
  justify-content: center;
  padding: 12px;
  margin: 20px auto;
  font-size: 10px;
  color: #282828;
`

export const StyledText = styled.div`
  color: grey;
  font-size: 15px;
`

export const SectionSpaceElemenet = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ReviewWarningWrapper = styled.div`
  position: relative;
`

export const StyledWarning = styled(Alert)`
  background: rgba(254, 203, 77, 0.15);
  border: 1px solid #8e6601;
  border-radius: 6px;
  color: #8e6601;
  font-weight: 600;
  padding: 8px 172px 8px 55px;

  & .ant-alert-icon {
    top: 10px;
    left: 16px;
    font-size: 20px;
    color: #8e6601;
  }

  & .ant-alert-message {
    color: #8e6601;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 2px;
  }

  & .ant-alert-description {
    color: #8e6601;
    font-weight: 600;
    font-size: 12px;
  }

  a {
    color: #8e6601;
    font-weight: 600;
    text-decoration: underline;
  }

  a:hover {
    color: ${themeColor};
  }
`

export const MarkTestAsReviewedButton = styled.button`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  background: #8e6601;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #7a5701;
    color: #ffffff;
  }
`

/* ----- MarkTestAsReviewedModal ----- */
const GREEN = '#158463'

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 6px;
  }
  .ant-modal-body {
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
`

export const ModalTitle = styled.p`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  color: #000000;
`

export const CloseIcon = styled(Icon)`
  font-size: 20px;
  color: #000000;
  cursor: pointer;
`

export const ModalDivider = styled.div`
  height: 1px;
  width: 100%;
  background: #e0e0e0;
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px;
`

export const ModalBodyText = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #000000;
`

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  background: #f5f5f5;

  i {
    font-size: 20px;
    color: #000000;
  }
`

export const InfoText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
`

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 24px;
`

const ModalButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 16px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const CancelButton = styled(ModalButton)`
  background: #ffffff;
  border: 1px solid ${GREEN};
  color: ${GREEN};
`

export const ConfirmButton = styled(ModalButton)`
  min-width: 150px;
  background: ${GREEN};
  border: 1px solid ${GREEN};
  color: #ffffff;
`
